<template>
	<div id="currentSchedule">
		<time-traveller
			v-if="!!dates.MIN_DATE"
			:dateOptions="dates"
			:expandedDate="getExpandedDate()"
			@timeTravel="refreshSchedule"
		/>

		<section class="toggle-bar hidden-print row">
			<div class="col-xs-12 col-md-6 col-lg-3 bold">
				<toggle-button
					v-model="scheduleOptions.showCourseSections"
					:css-colors="true"
					:label="$t( 'MAIN_CONTENT.CurrentSchedule.showCourseSectionTitleCase' )"
					:ariaLabel="$t( 'MAIN_CONTENT.CurrentSchedule.showCourseSectionTitleCase' )"
					:showInFront="false"
				/>
			</div>
			<div class="col-xs-12 col-md-6 col-lg-2 bold">
				<toggle-button
					v-model="scheduleOptions.showColors"
					:css-colors="true"
					:label="$t( 'MAIN_CONTENT.CurrentSchedule.showColorTitleCase' )"
					:ariaLabel="$t( 'MAIN_CONTENT.CurrentSchedule.showColorTitleCase' )"
					:showInFront="false"
				/>
			</div>
			<div class="col-xs-12 col-md-6 col-lg-2 bold">
				<toggle-button
					v-model="scheduleOptions.showCourseTimes"
					:css-colors="true"
					:label="$t( 'MAIN_CONTENT.CurrentSchedule.showCourseTimesTitleCase' )"
					:ariaLabel="$t( 'MAIN_CONTENT.CurrentSchedule.showCourseTimesTitleCase' )"
					:showInFront="false"
				/>
			</div>
		</section>

		<tabs
			:options="{ useUrlFragment: false, defaultTabHash: selectedTab }"
			v-if="dataLoaded"
		>
			<tab
				:name="school.SCHOOL_TITLE"
				v-for="(school, schoolIndex) in formattedData.SCHOOLS"
				:key="`school_${schoolIndex}`"
				:id="school.SCHOOL_ID"
				tabindex="0"
			>
				<section class="current-schedule">
					<div class="table-responsive">
						<table class="table table-current-schedule usa-table usa-table--borderless">
							<thead>
								<tr>
									<th class="period-col" scope="col" tabindex="0"></th>
									<th
										v-for="(day, dayIndex) in formattedData.DAYS[school.SCHOOL_ID]"
										:key="`day_header_${dayIndex}`"
										class="day-head"
										scope="col"
										tabindex="0"
									>
										<abbr>
											<div v-for="(cycleDay) in day.CYCLE_DAYS" :key="`CYCLE_DAYS_${ cycleDay }`">{{ cycleDay.DAY_DESC }}</div>
										</abbr>
										<div>
											<!-- {{ day.CALENDAR_DAY | date( 'MM-DD-YYYY', null, getSelectedLocale.LOCALE_CODE ) }} <br /><small>({{ day.CALENDAR_DAY | day(momentLibrary, 'MM-DD-YYYY', null, getSelectedLocale.LOCALE_CODE ) }})</small> -->
											{{ day.CALENDAR_DAY | date( 'MM-DD-YYYY', null, getSelectedLocale.LOCALE_CODE ) }} <br /><small>({{ day.CALENDAR_DAY | day( 'MM-DD-YYYY' ) }})</small>
										</div>
									</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="(per, periodIndex) in formattedData.PERIODS[school.SCHOOL_ID]">
									<template v-if="school.SCHOOL_ID.toString() === per.SCHOOL_ID.toString() && per.HIDE_ON_SCHEDULE_FLG === 'N' && hasCourses(school.SCHOOL_ID, `${per.PERIOD_CODE}`)">
										<tr
											class="schedule-class"
											scope="row"
											:key="`period_${periodIndex}`"
										>
											<td
												class="period-col"
												tabindex="0"
											>
												<strong>
													{{ per.PERIOD_CODE }}
												</strong>
											</td>
											<template
												v-for="(day, dayIndex) in formattedData.DAYS[school.SCHOOL_ID]"
											>
												<td
													:key="`school_${schoolIndex}_day_${dayIndex}`"
												>
													<template v-for="(sch, scheduleIndex) in schedule[school.SCHOOL_ID]">
														<template v-if="checkIfShow(school, sch, per, day)">
															<!-- With colors -->
															<div
																tabindex="0"
																v-if="scheduleOptions.showColors"
																:style="`background-color: #${sch.COLOR_HEX}; padding-left: 5px;`"
																:key="`schedule_${scheduleIndex}_day_${dayIndex}`"
															>
																<div class="class-head">
																	<router-link :to="{ name: 'ClassPageHome', params: { courseSectionGUID: sch.COURSE_SECTION_GUID } }" v-if="showRole('GRADES_FLG')">
																		<span>
																			<strong>{{ sch.COURSE_TITLE }}</strong>
																		</span>
																	</router-link>
																	<span v-else>
																		<strong>{{ sch.COURSE_TITLE }}</strong>
																	</span>
																</div>
																<div class="class-body">
																	<div v-if="scheduleOptions.showCourseSections">
																		{{ sch.COURSE_ID }} - {{ sch.SECTION_ID }} <br/>
																	</div>
																	<div>{{ sch.STAFF_NAME }}</div>
																	<div>RM {{ sch.ROOM_CODE }} {{ sch.DURATION_DESC }} {{sch.DAY_CODE}} </div>
																	<div v-if="scheduleOptions.showCourseTimes">
																		{{ sch.DETERMINED_START_TIME | time }} - {{ sch.DETERMINED_END_TIME | time }}
																	</div>
																</div>
															</div>
															<!-- Without colors -->
															<div
																tabindex="0"
																v-if="!scheduleOptions.showColors"
																style="padding-left: 5px;"
																:key="`schedule_${scheduleIndex}_day_${dayIndex}`"
															>
																<div class="class-head">
																	<router-link :to="{ name: 'ClassPageHome', params: { courseSectionGUID: sch.COURSE_SECTION_GUID } }" v-if="showRole('GRADES_FLG')">
																		<span>
																			<strong>{{ sch.COURSE_TITLE }}</strong>
																		</span>
																	</router-link>
																	<span v-else>
																		<strong>{{ sch.COURSE_TITLE }}</strong>
																	</span>
																</div>
																<div class="class-body">
																	<div v-if="scheduleOptions.showCourseSections">
																		{{ sch.COURSE_ID }} - {{ sch.PERIOD_CODE }}
																	</div>
																	<div>{{ sch.STAFF_NAME }}</div>
																	<div>{{ $t('MAIN_CONTENT.CurrentSchedule.rm') }} {{ sch.ROOM_CODE }} {{ sch.DURATION_DESC }}</div>
																	<div v-if="scheduleOptions.showCourseTimes">
																		{{ sch.DETERMINED_START_TIME | time }} - {{ sch.DETERMINED_END_TIME | time }}
																	</div>
																</div>
															</div>
															<br :key="`break_line_schedule_${scheduleIndex}_day_${dayIndex}`" />
														</template>
													</template>
												</td>
											</template>
										</tr>
									</template>
								</template>
							</tbody>
						</table>
					</div>
				</section>
			</tab>
		</tabs>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import { Tabs, Tab } from 'vue-tabs-component';

	import CurrentSchedule from '../../api/CurrentSchedule.js';
	import CurrentSchoolYear from '../../api/CurrentSchoolYear.js';

	import TimeTraveller from '../shared/TimeTraveller.vue';

	import SapphireToggle from "COMMONS/SapphireToggle/SapphireToggle.vue";

	export default {
		name: 'CurrentSchedule',
		data() {
			return {
				currentDate: moment(),
				moment: moment,
				selectedTab: null,
				dates: {
					SELECTED_DATE:      null,
					MAX_DATE:						null,
					MIN_DATE:						null,
					SCHOOL_YEAR_START:	null,
					SCHOOL_YEAR_END:		null
				},
				formattedData: {},
				schedule: {},
				periods: [],
				days: [],
				dayOrder: [],
				dayCodes: {},
				scheduleOptions: {
					showCourseSections: false,
					showCourseTimes: false,
					showColors: true
				},
				matrix: {},
				matrixLoaded: false,
				dataLoaded: false,
				courseColors: [
					'#C5E8FF',
					'#DDC7FF',
					'#FFEDDC',
					'#FFCCCC',
					'#DCFFE3',
					'#E1FFF8',
					'#B9B9DB',
					'#CFB8D8'
				],
				momentLibrary: moment
			};
		},
		computed: {
			...mapGetters([
				'selectedStudent',
				'roleRules',
				'role',
				'getSelectedLocale'
			]),
			daysInOrder() {
				if(!this.formattedData || !this.formattedData.DAYS) {
					return [];
				};

				return Object.keys(this.formattedData.DAYS).sort();
			},
			daysAreSorted() {
				return this.daysInOrder.length;
			},
			// an array of only those periods flagged not to hide on schedule
			schedulePeriods() {
				if(!this.periods) {
					return [];
				};

				return this.periods.filter(per => { return per.HIDE_ON_SCHEDULE_FLG === 'N'; });
			}
		},
		components: {
			Tabs,
			Tab,
			TimeTraveller,
			"toggle-button": SapphireToggle
		},
		methods: {
			checkIfShow(school, sch, per, day){
				if(`${school.SCHOOL_ID}` === `${sch.SCHOOL_ID}` && `${sch.PERIOD_CODE.toString()}` === `${per.PERIOD_CODE.toString()}` && this.isMatchingDayCode(sch, day)){
					if((sch.ADD_DROP_FLG !== 'D' || (sch.ADD_DROP_FLG === 'D' && moment(day.CALENDAR_DAY, "MM-DD-YYYY").isBefore(moment(sch.DROP_DATE))))){
						if( moment(day.CALENDAR_DAY, "MM-DD-YYYY").isSameOrAfter(moment(sch.ADD_DATE)) ){
							return true;
						}
					}
				}
				return false;
			},
			showRole(flag) {
				// In try/catch so that it will always load rather than break on error(s) for keys not existing
				try {
					return this.roleRules[flag] === 'Y';
				} catch(error) {
					return false;
				}
			},
			isMatchingDayCode(sch, day){
				return !!day.CYCLE_DAYS[sch.DAY_CODE] && !!day.MP_CODES[sch.MP_CODE];
			},
			getClassItemsFromMatrix(day, per) {
				if(!this.matrix[`${per.toString()}-${day}`]) {
					return [];
				};

				let matrixCell = this.matrix[`${per.toString()}-${day}`].courseInfo;
				// convert objects into array
				let classes = Object.keys(matrixCell);
				let classesArr = [];

				classes.forEach(sectionGuid => {
					classesArr.push(matrixCell[sectionGuid]);
				});

				return classesArr;
			},
			dayOnly(fullDate) {
				return fullDate.split('-').pop();
			},
			timeOnly(fullStamp) {
				if(!fullStamp) {
					return '';
				};

				let dayArr = fullStamp.split(' ');
				let hourMins = dayArr[3].split(':');
				hourMins.pop();

				return hourMins.join(':');
			},
			loadCurrentYear() {
				const self = this;

				let current = new CurrentSchoolYear({
					query: {
						student_rid: self.selectedStudent.STUDENT_RID
					}
				});

				const promise = current.get();

				promise.then(response => {
					let currentDate = moment();
					// if saturday or sunday we want to show the next school week.
					if( currentDate.weekday() == 0 || currentDate.weekday() == 6 ){
						currentDate.add(1, 'week');
					}
					

					// Picking the earliest start datee and latest end date of all the schools a student attends.
					let schoolStartDate = '';
					let schoolEndDate = '';
					const schoolYears = current.getResponseData();
					for( let schoolId in schoolYears){
						let tempSchoolStartDate = moment(schoolYears[schoolId].SCHOOL_START_DATE);
						if( schoolStartDate === '' || schoolStartDate.isAfter(tempSchoolStartDate)) {
							schoolStartDate = tempSchoolStartDate;
						}

						let tempSchoolEndDate = moment(schoolYears[schoolId].SCHOOL_END_DATE);
						if( schoolEndDate === '' || schoolEndDate.isBefore(tempSchoolEndDate) ){
							schoolEndDate = tempSchoolEndDate;
						}
					}
					
					if( currentDate.isBefore(schoolStartDate) ) {
						currentDate = schoolStartDate;
					} else if( currentDate.isAfter( schoolEndDate ) ) {
						currentDate = schoolEndDate;
					}

					let date = {
						START: moment( currentDate ).isoWeekday( 1 ).format( "MM/DD/YYYY" ),
						END: moment( currentDate ).isoWeekday( 5 ).format( "MM/DD/YYYY" )
					};

					let dates = {
						SCHOOL_YEAR_START: schoolStartDate.format( "MM/DD/YYYY" ),
						SCHOOL_YEAR_END: schoolEndDate.format( "MM/DD/YYYY" ),
						MIN_DATE: date.START,
						MAX_DATE: date.END,
						SELECTED_DATE: currentDate.format( "MM/DD/YYYY" )
					};

					self.$set( self, "dates", dates );

					self.loadSchedule();
				});
			},
			loadSchedule() {
				const self = this;

				let schedule = new CurrentSchedule({
					routeParams: 'schedule',
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						start_date: self.dates.MIN_DATE,
						end_date: self.dates.MAX_DATE
					}
				});

				const promise = schedule.get();

				promise.then(response => {
					self.$set( self, 'schedule', schedule.getResponseData() );

					self.loadCalendarDays();
				});
			},
			loadCalendarDays() {
				const self = this;

				let schedule = new CurrentSchedule({
					routeParams: {
						settings: 'calendar/days'
					},
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						start_date: self.dates.MIN_DATE,
						end_date: self.dates.MAX_DATE
					}
				});

				const promise = schedule.get();

				promise.then(response => {
					self.$set(self, 'days', schedule.getResponseData());
					for(let s in this.selectedStudent.ENROLLMENT) {
						self.loadDayCodes(this.selectedStudent.ENROLLMENT[s].SCHOOL_ID);
					}
				});
			},
			loadDayCodes(schoolID) {
				let self = this;

				let schedule = new CurrentSchedule({
					routeParams: {
						settings: 'calendar/cycle-days'
					},
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						start_date: self.dates.MIN_DATE,
						end_date: self.dates.MAX_DATE,
						school_id: schoolID
					}
				});

				const promise = schedule.get();

				promise.then(response => {
					self.$set(self.dayCodes, schoolID, schedule.getResponseData());
					self.loadCalendarPeriods();
				});
			},
			loadCalendarPeriods() {
				const self = this;

				let schedule = new CurrentSchedule({
					routeParams: {
						settings: 'calendar/periods'
					},
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						start_date: self.dates.MAX_DATE,
						end_date: self.dates.MIN_DATE

					}
				});

				const promise = schedule.get();

				promise.then(response => {
					self.$set(self, 'periods', schedule.getResponseData());
					self.$store.commit( "setError", false );
					self.formatData();
				});
			},
			formatData() {
				let days = this.formatDays();
				let schools = this.formatSchools();
				let periods = this.formatPeriodsBySchool();
				let formattedData = {
					PERIODS: periods,
					DAYS: days,
					SCHOOLS: schools
				};

				this.$set( this, 'formattedData', formattedData );
			},
			formatPeriodsBySchool() {
				let periodsBySchool = {};
				for(let s in this.selectedStudent.ENROLLMENT) {
					let periods = [];
					for(let p in this.periods) {
						let period = this.periods[p];
						if( period.SCHOOL_ID === this.selectedStudent.ENROLLMENT[s].SCHOOL_ID ){
							periods.push(period);
						}
					}

					periodsBySchool[this.selectedStudent.ENROLLMENT[s].SCHOOL_ID] = periods;
				}
		
				return periodsBySchool;
			},
			formatDays() {
				let daysBySchool = {};
				for(let s in this.selectedStudent.ENROLLMENT) {
					let days = {};
					for( let i=0; i<5; i++ ){
						days[ moment(this.dates.MIN_DATE).add(i, 'd').format('MM-DD-YYYY') ] = {
							CALENDAR_DAY: moment(this.dates.MIN_DATE).add(i, 'd').format('MM-DD-YYYY'),
							CYCLE_DAYS: {},
							MP_CODES: {},
						};
					}

					for(let d in this.days) {
						let day = this.days[d];
						if( day.SCHOOL_ID === this.selectedStudent.ENROLLMENT[s].SCHOOL_ID ){	
							days[moment(day.CALENDAR_DAY).format('MM-DD-YYYY')].CYCLE_DAYS[day.DAY_CODE] = day;
							days[moment(day.CALENDAR_DAY).format('MM-DD-YYYY')].MP_CODES[day.MP_CODE] = {
								MP_CODE: day.MP_CODE,
								MP_DESC: day.MP_DESC,
								MP_ORDER: day.MP_ORDER,
							};
						}
					}

					daysBySchool[this.selectedStudent.ENROLLMENT[s].SCHOOL_ID] = days;
				}
		
				return daysBySchool;
			},
			formatSchools() {
				let schools = {};

				for(let s in this.selectedStudent.ENROLLMENT) {
					let school = this.selectedStudent.ENROLLMENT[s];

					if(!schools[school.SCHOOL_ID]) {
						schools[school.SCHOOL_ID] = {
							CLASSES: this.formatClasses(school.SCHOOL_ID),
							SCHOOL_TITLE: school.SCHOOL_TITLE,
							SCHOOL_ID: school.SCHOOL_ID
						};

						if(!this.selectedTab) {
							this.selectedTab = school.SCHOOL_ID;
						}
					}
				}

				return schools;
			},
			formatClasses(schoolID) {
				let classes = {};

				// Add day code to classes
				for(let d in this.dayCodes[schoolID]) {
					let code = this.dayCodes[schoolID][d];

					if(code.SCHOOL_ID.toString() === schoolID.toString() && !classes[code.DAY_CODE]) {
						classes[code.DAY_CODE] = this.formatPeriods(schoolID, code.DAY_CODE);
					}
				}

				return classes;
			},
			formatPeriods(schoolID, dayCode) {
				let periods = {};

				for(let p in this.periods) {
					let period = this.periods[p];

					if(period.SCHOOL_ID.toString() === schoolID.toString() && !periods[period.PERIOD_CODE] && period.HIDE_ON_SCHEDULE_FLG === 'N') {
						periods[period.PERIOD_CODE] = this.formatCourses(schoolID, dayCode, period.PERIOD_CODE);
					}
				}

				return periods;
			},
			formatCourses(schoolID, dayCode, periodCode) {
				let courses = {};

				for(let s in this.schedule[schoolID]) {
					let course = this.schedule[schoolID][s];

					if(course.SCHOOL_ID.toString() === schoolID.toString() && course.DAY_CODE.toString() === dayCode.toString() && course.PERIOD_CODE.toString() === periodCode.toString() && !courses[course.COURSE_SECTION_GUID]) {
						courses[course.COURSE_SECTION_GUID] = course;
					}
				}

				this.dataLoaded = true;

				return courses;
			},
			getPeriodList(school) {
				let periods = [];

				for(let p in this.periods) {
					let period = this.periods[p];

					if(school.SCHOOL_ID.toString() === period.SCHOOL_ID.toString()) {
						periods.push(`${period.PERIOD_CODE}`);
					}
				}

				return periods;
			},
			getCourse(schoolID, dayCode, periodCode) {
				let course = {};

				for(let s in this.schedule) {
					let sched = this.schedule[s];

					if(sched.SCHOOL_ID.toString() === schoolID.toString() && sched.DAY_CODE.toString() === dayCode.toString() && sched.PERIOD_CODE.toString() === periodCode.toString()) {
						course = sched;
						break;
					}
				}

				return course;
			},
			hasCourses(schoolID, periodCode) {
				let hasCourse = false;

				for(let s in this.schedule[schoolID]) {
					let sch = this.schedule[schoolID][s];

					if(sch.SCHOOL_ID.toString() === schoolID.toString() && sch.PERIOD_CODE.toString() === periodCode.toString()) {
						hasCourse = true;
					}
				}

				return hasCourse;
			},
			getExpandedDate() {
				return moment(this.dates.MIN_DATE).format('dddd, MMMM D, YYYY');
			},
			createMatrix() {
				this.schedule.PERIODS.forEach(period => {
					this.daysInOrder.forEach(day => {
						let identifier = `${period.PERIOD_CODE}-${this.schedule.DAYS[day].DAY_CODE}`;
						let dayPeriod = {
							id: identifier,
							courseInfo: ''
						};

						this.$set(this.matrix, identifier, dayPeriod);
						this.populateMatrixCell(identifier);
					});
				});

				// set flag that matrix is loaded
				this.matrixLoaded = true;
			},
			// populate a single matrix cell
			populateMatrixCell(identifier) {
				// split id into period and day
				let idArr = identifier.split('-');

				// does the student have this period?
				if(!this.schedule.CLASSES[idArr[0]]) {
					return '';
				};

				// if so, populate the class(es)
				this.matrix[identifier].courseInfo = this.schedule.CLASSES[idArr[0]][idArr[1]]
					? this.schedule.CLASSES[idArr[0]][idArr[1]] : '';
			},
			refreshSchedule(start, end) {
				if( this.dates.MIN_DATE !== start && this.dates.MAX_DATE !== end ){
					this.dates.MIN_DATE = start;
					this.dates.MAX_DATE = end;

					if( start !== "Invalid date" || end !== "Invalid date" ) {
						this.loadSchedule();
					}
				}
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'calendar-alt');
			this.$store.commit('setTitle', 'MAIN_CONTENT.CurrentSchedule.sideMenuCurrentScheduleLink');
			this.$store.commit('setUseHeader', true);

			this.loadCurrentYear();
		}
	};
</script>
